/** @jsxImportSource @emotion/react */

import { COLORS } from '@btime/constants'
import { css } from '@emotion/react'
import { identity, prop, propEq } from 'ramda'
// eslint-disable-next-line
import React from 'react'

import { HorizontalLine } from '../shapes/Line'
import { Text } from '../presentation/Text'
import { useSetTab, useTab, useTabOptions } from './TabsContext'
import FlexGrid from '../structure/FlexGrid'
import Link from '../actions/Link'

// TODO: Possibility to move some styles line color and useButtonStyle to TabsMenu
// TODO: Refactor and separato styles to ButtonTab and Tab
export const Tab = ({ children, label, color, active, onClick, size, fullWidth, useButtonStyle }) => {
  let finalColor = color || COLORS.white

  const style = css`
    display: block;
    position: relative;
    border-radius: 5px;
    ${!fullWidth ? 'margin: 0 1rem;' : ''}
    ${!!fullWidth ? 'flex: 1;' : ''}
		${!!useButtonStyle
      ? `
			padding: .3rem .7rem;
			margin: 0;
		`
      : ''}
		${useButtonStyle && active ? `background-color: ${finalColor};` : ''}

		& > .text {
      font-weight: 700;
      display: block;
      color: ${active ? finalColor : COLORS.dark5};
      ${useButtonStyle && active ? `color: ${COLORS.white};` : ''}
      padding: 0rem 0 0.6875rem 0;
      ${useButtonStyle ? 'padding: 0;' : ''}
    }

    & > .line {
      ${useButtonStyle ? 'display: none;' : ''}
      position: absolute;
      bottom: 0;
      right: 0;
      left: 0;
    }
  `

  return (
    <Link css={style} onClick={onClick}>
      <Text noWrap size={size} align="center">
        {children || label}
      </Text>
      {!!active && <HorizontalLine lineColor={finalColor} />}
    </Link>
  )
}

const TabsMenuWrapper = ({ children, justify }) => (
  <div className="tabsMenu">
    <FlexGrid justify={justify}>{children}</FlexGrid>
  </div>
)

// TODO: Control colors with props
const TabsMenu = ({ children, options, justify, t, lightColors }) => {
  const activeTab = useTab()
  const setTab = useSetTab()
  const tabOptions = useTabOptions()
  options = options || tabOptions

  if (!options || !!children) {
    return <TabsMenuWrapper justify={justify}>{children}</TabsMenuWrapper>
  }

  t = t || identity
  return (
    <TabsMenuWrapper justify={justify}>
      {options.map(tab => {
        const active = propEq('name', prop('name', tab), activeTab)
        return (
          <Tab
            key={tab.name}
            active={active}
            color={!lightColors && (active ? COLORS.purple : COLORS.dark3)}
            onClick={() => setTab(tab)}
          >
            {tab.label || t(tab.name, tab.name)}
          </Tab>
        )
      })}
    </TabsMenuWrapper>
  )
}

export default TabsMenu
